module.exports = __webpack_public_path__ + "img/headphone.3e31772c.svg";